// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventSimple
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.cbor.Bstr

fun EventSimple.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Ukp71F6hCzcYcwrMAK3cFnQSyDruR_JFJHl6r10A8Yk")
val EventSimple_cborSchemaId = ByteString(82, 74, 123, -44, 94, -95, 11, 55, 24, 115, 10, -52, 0, -83, -36, 22, 116, 18, -56, 58, -18, 71, -14, 69, 36, 121, 122, -81, 93, 0, -15, -119)

fun EventSimple.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Simple")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("data", Bstr(this.data.toByteArray()))
    return builder.end().build()
}

fun EventSimple_fromDataItem(dataItem: DataItem): EventSimple {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val data = ByteString(dataItem["data"].asBstr)
    return EventSimple(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        data = data,
    )
}
